const NUMBER = "[+-]?(?:\\d+(?:\\.\\d*)?|\\.\\d+)";
const numeric = new RegExp(`^${NUMBER}$`);
const fraction = new RegExp(`^(${NUMBER})\\s*/\\s*(${NUMBER})$`);
const latex = new RegExp(`^([+-]?)(?:(\\d+)\\s*)?\\\\(?:dfrac|tfrac|frac)\\{(${NUMBER})\\}\\{(${NUMBER})\\}$`);

export function parseFractionValue(input) {
  if (typeof input === "number") return Number.isFinite(input) ? input : null;
  if (typeof input !== "string" || input.length > 160) return null;
  let text = input.trim().replace(/,/g, ".").replace(/[−–]/g, "-")
    .replace(/[\u00a0\u202f\u200b]/g, " ").replace(/\s+/g, " ");
  const vulgar = text.match(/^([+-]?)(\d*)([½¼¾])$/);
  if (vulgar) return (vulgar[1] === "-" ? -1 : 1) * (Number(vulgar[2] || 0) + { "½": 0.5, "¼": 0.25, "¾": 0.75 }[vulgar[3]]);
  const mixed = text.match(/^([+-]?)(\d+) (\d+)\s*\/\s*(\d+)$/);
  if (mixed) {
    const denominator = Number(mixed[4]);
    return denominator === 0 ? null : (mixed[1] === "-" ? -1 : 1) * (Number(mixed[2]) + Number(mixed[3]) / denominator);
  }
  const tex = text.match(latex);
  if (tex) {
    const numerator = Number(tex[3]), denominator = Number(tex[4]);
    if (denominator === 0 || (tex[2] !== undefined && (numerator < 0 || denominator < 0))) return null;
    const value = (tex[1] === "-" ? -1 : 1) * (Number(tex[2] || 0) + numerator / denominator);
    return Number.isFinite(value) ? value : null;
  }
  if (text.startsWith("(") && text.endsWith(")")) text = text.slice(1, -1).trim();
  const match = text.match(fraction);
  const value = match ? Number(match[1]) / Number(match[2]) : numeric.test(text) ? Number(text) : NaN;
  return Number.isFinite(value) ? value : null;
}
